import React, { forwardRef } from "react";
import { BSDiv } from "../../types";

export const CardHeader = forwardRef<HTMLDivElement, BSDiv>(
  ({ children, className = "", ...props }, ref) => {
    return (
      <div {...props} className={`card-header ${className}`} ref={ref}>
        {children}
      </div>
    );
  }
);